import { NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { USER_INFO_CONFIG } from "../../config/api";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class AccountSettingsInfoService {
    constructor(ngZone, http) {
        this.ngZone = ngZone;
        this.http = http;
        this.visible = new BehaviorSubject(null);
        this.config = USER_INFO_CONFIG;
    }
    show() {
        this.visible.next(true);
    }
    hide() {
        this.visible.next(false);
    }
    loadData() {
        return this.http.post(this.config.info, {});
    }
    setData(phone, firstName, lastName, userName) {
        return this.http.post(this.config.save, { phone, firstName, lastName, userName });
    }
}
AccountSettingsInfoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AccountSettingsInfoService_Factory() { return new AccountSettingsInfoService(i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(i1.HttpClient)); }, token: AccountSettingsInfoService, providedIn: "root" });
